import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CalendarioJudicialDto } from '@models/calendarioJudicial/calendarioJudicialDto.model';
import { CalendarioJudicialFilter } from '@models/calendarioJudicial/calendarioJudicialFilter.model';
import { CreateCalendarioJudicialRequest } from '@models/calendarioJudicial/createCalendarioJudicialDto.model';
import { UpdateCalendarioJudicialRequest } from '@models/calendarioJudicial/updateCalendarioJudicialDto.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class CalendarioJudicialService {

  constructor(private http: HttpClient) { }

  create(createCalendarioJudicialRequest: CreateCalendarioJudicialRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/CalendarioJudicial/Create", createCalendarioJudicialRequest);
  }

  getAllByFilter(calendarioJudicialFilter: CalendarioJudicialFilter): Observable<CalendarioJudicialDto[]> {
    return this.http.post<CalendarioJudicialDto[]>("/api/CalendarioJudicial/GetAllByFilter", calendarioJudicialFilter);
  }

  update(updateCalendarioJudicialRequest: UpdateCalendarioJudicialRequest): Observable<any> {
    return this.http.put<any>("/api/CalendarioJudicial/Update", updateCalendarioJudicialRequest);
  }

  getAll(): Observable<CalendarioJudicialDto[]> {
    return this.http.get<CalendarioJudicialDto[]>("/api/CalendarioJudicial/GetAll");
  }

  getById(id: number): Observable<CalendarioJudicialDto> {
    return this.http.get<CalendarioJudicialDto>("/api/CalendarioJudicial/GetById?id=" + id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/CalendarioJudicial/Delete?id=" + id);
    else
      return of(null)
  }
}
